export interface WaitlistUtm {
  source?: string | null;
  medium?: string | null;
  campaign?: string | null;
  term?: string | null;
  content?: string | null;
}

export interface WaitlistAttribution {
  ip?: string | null;
  userAgent?: string | null;
  referrer?: string | null;
  landingPage?: string | null;
  utm?: WaitlistUtm | null;
}

function clean(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
}

/**
 * Human-readable acquisition source for a waitlist signup, derived from the
 * stored attribution metadata. UTM source wins; otherwise the referrer host;
 * otherwise "Direct".
 */
export function deriveWaitlistSource(metadata: Record<string, unknown> | null | undefined): string {
  const attribution = (metadata ?? {}) as WaitlistAttribution;

  const utmSource = clean(attribution.utm?.source);
  if (utmSource) return utmSource;

  const referrer = clean(attribution.referrer);
  if (referrer) {
    try {
      return new URL(referrer).hostname.replace(/^www\./, '');
    } catch {
      return referrer;
    }
  }

  return 'Direct';
}
